import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DomainGroupingModal from './domain-grouping-modal';

import {
    saveDomainGroupFromModal,
    selectDomainGroup,
    dismissDomainGroupingForm,
    updateDomainsInSelectedGroup
} from '../../common/actions/domain-groups-action-creators';
import { closeModal } from '../../common/actions/modal-action-creators';

import {
    domainGroupsIsUpdating,
} from '../../common/selectors/domain-groups-selectors';
import {
    domainGroupFormWarningSelector,
    isEditDomainGroupSelector,
    modalDomainGroupIdSelector,
    modalPreselectedDomainsForAGroupSelector,
    isDomainGroupFormInvalidSelector,
    isAssigningDomainsToGroupSelector,
} from './domain-grouping-selectors';

export const DomainGroupingModalContainer = ( {
    assignMode,
    closeModal,
    dismissDomainGroupingForm,
    editMode,
    isSaveDisabled,
    isUpdating,
    open,
    preselectedDomains,
    saveDomainGroupFromModal,
    selectedGroupId,
    selectDomainGroup,
    updateDomainsInSelectedGroup,
    warnings,
} ) => {

    useEffect( () => {
        if( selectedGroupId ){
            selectDomainGroup( selectedGroupId );
        }
    },
    [selectDomainGroup, selectedGroupId] );

    useEffect( () => {
        if( assignMode ){
            updateDomainsInSelectedGroup( preselectedDomains );
        }
    },
    [assignMode, updateDomainsInSelectedGroup, preselectedDomains] );

    function handleDismiss(){
        dismissDomainGroupingForm();
        closeModal();
    }

    return (
        <DomainGroupingModal
            editMode={editMode}
            isUpdating={isUpdating}
            isSaveDisabled={isSaveDisabled}
            onDismiss={handleDismiss}
            onSave={saveDomainGroupFromModal}
            open={open}
            selectedGroupId={selectedGroupId}
            warnings={warnings}
        />
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => {
    return {
        assignMode: isAssigningDomainsToGroupSelector( state ),
        editMode: isEditDomainGroupSelector( state ),
        isSaveDisabled: isDomainGroupFormInvalidSelector( state ),
        isUpdating: domainGroupsIsUpdating( state ),
        preselectedDomains: modalPreselectedDomainsForAGroupSelector( state ),
        selectedGroupId: modalDomainGroupIdSelector( state ),
        warnings: domainGroupFormWarningSelector( state ),
    };
};

DomainGroupingModalContainer.propTypes = {
    assignMode: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    dismissDomainGroupingForm: PropTypes.func.isRequired,
    editMode: PropTypes.bool.isRequired,
    isSaveDisabled: PropTypes.bool.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    preselectedDomains: PropTypes.arrayOf( PropTypes.string ).isRequired,
    saveDomainGroupFromModal: PropTypes.func.isRequired,
    selectDomainGroup: PropTypes.func.isRequired,
    selectedGroupId: PropTypes.number,
    updateDomainsInSelectedGroup: PropTypes.func.isRequired,
    warnings: PropTypes.array.isRequired,
};

export default connect(
    mapStateToProps,
    {
        closeModal,
        dismissDomainGroupingForm,
        saveDomainGroupFromModal,
        selectDomainGroup,
        updateDomainsInSelectedGroup,
    },
)( DomainGroupingModalContainer );
